import { queryOptions, useQuery } from '@tanstack/react-query';

import { getApiClient } from '@cast/api-client';

const INVENTORY_REGIONS_QUERY_KEY = 'inventory-regions';

const getInventoryRegionsQueryKey = () =>
  [INVENTORY_REGIONS_QUERY_KEY] as const;

const getRegionsQueryOptions = () =>
  queryOptions({
    queryKey: getInventoryRegionsQueryKey(),
    queryFn: () =>
      getApiClient()
        .inventory.listRegions({ pageSize: 99999 })
        .then(({ data }) => data.regions),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

export const useRegionsQuery = () => {
  const { data: regions, ...rest } = useQuery(getRegionsQueryOptions());
  return { regions, ...rest };
};
